import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";

export type SirenDefaultBroadcastConfig = {
    id: string;
    clientID?: string;
    departmentID?: string;
    broadcastDuration: number;
    broadcastDurationDisplayFormat: string;
    cycleCount: number;
    cycleInterval: number;
    cycleIntervalDisplayFormat: string;
    deliveryMethodInterval: number;
    deliveryMethodIntervalDisplayFormat: string;
    updatedBy: string;
    updatedAt: string;
    clientName: string;
    departmentName: string;
};

export async function getSirenDefaultBroadcastConfigs(page: number, limit: number, clientID?: string): Promise<PaginatedResponseV2<SirenDefaultBroadcastConfig> | null> {
    try {
        const params: Record<string, string | number> = {page, limit};
        if (clientID) params.clientID = clientID;
        const res = await platformAPI.get<PaginatedResponseV2<SirenDefaultBroadcastConfig>>("api/siren/default-broadcast-config", {params});
        return res.data;
    } catch {
        return null;
    }
}

export async function resolveSirenDefaultBroadcastConfig(clientID?: string, departmentID?: string): Promise<SirenDefaultBroadcastConfig | null> {
    try {
        const params: Record<string, string> = {};
        if (clientID) params.clientID = clientID;
        if (departmentID) params.departmentID = departmentID;
        const res = await platformAPI.get<SirenDefaultBroadcastConfig>("api/siren/default-broadcast-config/resolve", {params});
        return res.data;
    } catch {
        return null;
    }
}
